export default "/staticreactui/static/media/static/media/customer1.79869cc3.png";